<button
	mat-fab
	color="accent"
	(click)="onBtnClicked()"
>
	<mat-icon svgIcon="my_location"></mat-icon>
</button>
